import { useI18n } from '~/compositions/i18n'
import CDynamicFormAddressTextField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormAddressTextField.vue'
import CDynamicFormTextField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormTextField.vue'
import CDynamicFormBooleanField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormBooleanField.vue'
import CDynamicFormEmailField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormEmailField.vue'
import CDynamicFormTelephone from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormTelephone.vue'
import CDynamicFormAuditServicingScheduleField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormAuditServicingScheduleField.vue'
import CDynamicFormGeolocationField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormGeolocationField.vue'
import CDynamicFormNumberField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormNumberField.vue'
import CDynamicFormRichStringField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormRichStringField.vue'
import CDynamicFormAuditShopField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormAuditShopField.vue'
import CDynamicFormOptions from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormOptions.vue'
import CDynamicFormDateField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormDateField.vue'
import CDynamicAuditOptionsField from '~/components/shared/configurable/dynamic-form/fields/CDynamicAuditOptionsField.vue'
import CDynamicFormAuditServicingMakesField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormAuditServicingMakesField.vue'
import CDynamicFormPerksField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormPerksField.vue'
import CDynamicFormAuditServicingCategoryField from '~/components/shared/configurable/dynamic-form/fields/CDynamicFormAuditServicingCategoryField.vue'

export function useDynamicFormField() {
  const { t } = useI18n()

  function getFieldComponent(type: string, name: string) {
    switch (type) {
      case 'NameValidator':
      case 'String': {
        if (name === 'address') {
          return CDynamicFormAddressTextField
        }
        if (name === 'business_representative_birthday') {
          return CDynamicFormDateField
        }
        return CDynamicFormTextField
      }
      case 'Boolean': {
        return CDynamicFormBooleanField
      }
      case 'EmailValidator': {
        return CDynamicFormEmailField
      }
      case 'Telephone': {
        return CDynamicFormTelephone
      }
      case 'AuditServicingSchedule': {
        return CDynamicFormAuditServicingScheduleField
      }
      case 'ServicingMakesValidator': {
        return CDynamicFormAuditServicingMakesField
      }
      case 'ServicingCategoryValidator':
      case 'PackageCategoryValidator': {
        return CDynamicFormAuditServicingCategoryField
      }
      case 'GeolocationValidator': {
        return CDynamicFormGeolocationField
      }
      case 'AuditOptionValidator': {
        return CDynamicAuditOptionsField
      }
      case 'Number': {
        return CDynamicFormNumberField
      }
      case 'RichStringValidator': {
        return CDynamicFormRichStringField
      }
      case 'AuditShopValidator': {
        return CDynamicFormAuditShopField
      }
      case 'OptionsValidator': {
        return CDynamicFormOptions
      }
      case 'RegexValidator': {
        return CDynamicFormTextField
      }
      case 'IbanValidator': {
        return CDynamicFormTextField
      }
      case 'PerksValidator': {
        return CDynamicFormPerksField
      }
      case 'VinNumberField': {
        return CDynamicFormTextField
      }
      default: {
        return null
      }
    }
  }
  function getFieldLabel(name: string, context: string = '') {
    switch (name) {
      case 'name':
      case 'first_name': {
        return t('name')
      }
      case 'last_name': {
        return t('last name')
      }
      case 'active':
      case 'activated': {
        if (context === 'auditor') {
          return t('active::male')
        }
        return t('active')
      }
      case 'email': {
        return 'Email'
      }
      case 'telephone1': {
        return `${t('telephone')} 1`
      }
      case 'telephone2': {
        return `${t('telephone')} 2`
      }
      case 'servicing_schedule': {
        return t('working hours')
      }
      case 'geolocation': {
        return t('location')
      }
      case 'address': {
        return t('address')
      }
      case 'audit_options': {
        return t('audit options')
      }
      case 'audit_means': {
        return t('audit means')
      }
      case 'servicing_makes': {
        return t('supported makes')
      }
      case 'servicing_category': {
        return t('supported_makes')
      }
      case 'category': {
        return t('category')
      }
      case 'price': {
        return t('price')
      }
      case 'audit_points_count': {
        return t('audit points count')
      }
      case 'description': {
        return t('description')
      }
      case 'audit_shop': {
        return t('audit shop')
      }
      case 'range': {
        return `${t('radius')} ${t('in')
          .toString()
          .toLowerCase()} ${t('km')
          .toString()
          .toLowerCase()}`
      }
      case 'business_name':
        return t('name')
      case 'business_email':
        return 'Email'
      case 'business_vat':
        return t('tin::taxation')
      case 'business_headquarter_postal_code':
        return `${t('p.c.')}`.toUpperCase()
      case 'business_headquarter_address_line1':
        return t('address')
      case 'business_headquarter_city':
        return t('city')
      case 'business_headquarter_region':
        return t('region')
      case 'business_representative_first_name':
        return t('name')
      case 'business_representative_last_name':
        return t('last name')
      case 'business_representative_country_of_residence':
        return t('country of residence')
      case 'business_representative_nationality':
        return t('nationality')
      case 'business_representative_birthday':
        return t('date of birth')
      case 'perks':
        return t('perks')
      default: {
        return null
      }
    }
  }

  return { getFieldComponent, getFieldLabel }
}
